
import { supabase } from "@/integrations/supabase/client";

// Function to track page views
export async function trackPageView(path: string, referrer?: string) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;

    await supabase.from('page_views').insert({
      user_id: session.user.id,
      page_path: path,
      referrer: referrer || null
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
}

// Function to track user events
export async function trackEvent(eventType: string, eventData: Record<string, any> = {}) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;

    await supabase.from('analytics_events').insert({
      user_id: session.user.id,
      event_type: eventType,
      event_data: eventData
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
}

// Function to track performance metrics
export async function trackPerformance(metricName: string, value: number, context: Record<string, any> = {}) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;

    await supabase.from('performance_metrics').insert({
      user_id: session.user.id,
      metric_name: metricName,
      metric_value: value,
      context
    });
  } catch (error) {
    console.error('Error tracking performance:', error);
  }
}
